module.exports = __webpack_public_path__ + "static/img/zh_CN3.63da817.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile/zh_CN3.png
// module id = 3sdA
// module chunks = 1